import { BaseResponseDto } from "types/api/baseResponseDto";
import { CustomColumnScope } from "types/tenantConfig";

import { makeCancellableAPIRequest } from "./index";

const TagsAPI = {
  fetchTagValues({
    scope,
    ...data
  }: {
    key: string;
    value?: string;
    scope: CustomColumnScope;
  }) {
    const scopeText =
      scope === CustomColumnScope.PRODUCT
        ? "product"
        : scope === CustomColumnScope.SUB_PRODUCT
          ? "sub-product"
          : scope === CustomColumnScope.ASSETS
            ? "ASSET"
            : scope;
    return makeCancellableAPIRequest<
      BaseResponseDto<{ list: { value: string }[] }>
    >("POST", `/api/tags/${scopeText}/values`, {
      data,
    });
  },
  fetchTagValuesV2({
    scope,
    ...data
  }: {
    key: string;
    value?: string;
    scope: CustomColumnScope;
  }) {
    const scopeText =
      scope === CustomColumnScope.PRODUCT
        ? "product"
        : scope === CustomColumnScope.SUB_PRODUCT
          ? "sub-product"
          : scope === CustomColumnScope.ASSETS
            ? "ASSET"
            : scope;
    return makeCancellableAPIRequest<
      BaseResponseDto<{ tagsCountPair: { [tag: string]: number } }>
    >("POST", `/api/v2/tags/${scopeText}/values`, {
      data,
    });
  },
};

export default TagsAPI;
